const CreatePatientFormValues = {
  patientUpdateStatus: "ADD",
  nationalId: "",
  subjectNumber: "",
  lastName: "",
  firstName: "",
  streetAddress: "",
  city: "",
  primaryPhone: "",
  email: "",
  gender: "",
  birthDateForDisplay: "",
  commune: "",
  education: "",
  maritialStatus: "",
  nationality: "",
  healthDistrict: "",
  healthRegion: "",
  otherNationality: "",
  photo: "",
  patientContact: {
    person: {
      firstName: "",
      lastName: "",
      primaryPhone: "",
      email: "",
    },
  },
};

export default CreatePatientFormValues;
